import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 懒加载：按需加载页面组件，减少首屏打包体积
const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue');
const About = () => import(/* webpackChunkName: "about" */ '../views/About.vue');
const Services = () => import(/* webpackChunkName: "services" */ '../views/Services.vue');
const Contact = () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue');
const Shipping = () => import(/* webpackChunkName: "shipping" */ '../views/Shipping.vue');
const RefrigeratedGoods = () => import(/* webpackChunkName: "refrigerated" */ '../views/RefrigeratedGoods.vue');
const OperableGoods = () => import(/* webpackChunkName: "operable" */ '../views/OperableGoods.vue');
const Consultation = () => import(/* webpackChunkName: "consultation" */ '../views/Consultation.vue');
const Business = () => import(/* webpackChunkName: "business" */ '../views/Business.vue');
const Careers = () => import(/* webpackChunkName: "careers" */ '../views/Careers.vue');

export default new Router({
	routes: [{
			path: '/',
			component: Home
		},
		{
			path: '/about',
			component: About
		},
		{
			path: '/services',
			component: Services,
			children: [{
					path: 'shipping',
					component: Shipping
				},
				{
					path: 'refrigerated',
					component: RefrigeratedGoods
				},
				{
					path: 'operable',
					component: OperableGoods
				},
				{
					path: 'consultation',
					component: Consultation
				},
			],
		},
		{
			path: '/contact',
			component: Contact,
			children: [{
					path: 'business',
					component: Business
				},
				{
					path: 'careers',
					component: Careers
				},
			]
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			};
		}
		return {
			x: 0,
			y: 0
		};
	},
});